var LiveChatService = /** @class */ (function () {
    function LiveChatService() {
        this.listeners = [];
        this.pendingState = null;
    }
    LiveChatService.prototype.openLiveAgent = function () {
        this.emitStatusChange(true);
    };
    LiveChatService.prototype.liveAgentClosed = function () {
        this.emitStatusChange(false);
    };
    LiveChatService.prototype.onLiveChatStateChange = function (callback) {
        var _this = this;
        if (this.pendingState !== null) {
            callback(this.pendingState);
        }
        this.listeners.push(callback);
        return function () {
            _this.listeners.splice(_this.listeners.indexOf(callback), 1);
        };
    };
    LiveChatService.prototype.emitStatusChange = function (isOpen) {
        if (this.listeners.length === 0) {
            this.pendingState = isOpen;
        }
        this.listeners.forEach(function (callback) {
            callback(isOpen);
        });
    };
    return LiveChatService;
}());
var liveChatService = new LiveChatService();

export { liveChatService };
